// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeadWorkModal-module__modalOverlay___aGtkK {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.LeadWorkModal-module__modalCard____Yo0W {
  width: 100%;
  max-width: 920px;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.LeadWorkModal-module__modalHeader___bDPT8 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px 14px;
  border-bottom: 1px solid #e5e7eb;
}

.LeadWorkModal-module__modalTitle___nggga {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.LeadWorkModal-module__modalSubtitle___Z2Xy6 {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.4;
  color: #6b7280;
}

.LeadWorkModal-module__closeButton___VCKmL {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
}

.LeadWorkModal-module__closeButton___VCKmL:hover {
  color: #111827;
}

.LeadWorkModal-module__modalBody___rfzQX {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 18px;
}

.LeadWorkModal-module__modalFooter___eP7Lw {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
}

.LeadWorkModal-module__footerSpacer___zwLPU {
  flex: 1 1 auto;
}

.LeadWorkModal-module__modalSecondaryAction___mS9YM {
  min-width: 64px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #4b5563;
  cursor: pointer;
}

.LeadWorkModal-module__modalSecondaryAction___mS9YM:disabled {
  color: #9ca3af;
  cursor: not-allowed;
}

.LeadWorkModal-module__modalDangerAction___A5q5e {
  border-color: #fecaca;
  color: #b91c1c;
}

.LeadWorkModal-module__modalDangerAction___A5q5e:disabled {
  border-color: #e5e7eb;
  color: #9ca3af;
}

.LeadWorkModal-module__modalPrimaryAction___Jy0ww {
  min-width: 64px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #1f2937;
  color: #ffffff;
  cursor: pointer;
}

.LeadWorkModal-module__modalPrimaryAction___Jy0ww:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: default;
}

.LeadWorkModal-module__modalSecondaryAction___mS9YM:focus-visible,
.LeadWorkModal-module__modalPrimaryAction___Jy0ww:focus-visible,
.LeadWorkModal-module__closeButton___VCKmL:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/LeadWorkModal/LeadWorkModal.module.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;EACA,mBAAA;AADF;;AAIA;EACE,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;;;EAGE,0BAAA;EACA,mBAAA;AADF","sourcesContent":["// Same chrome as ReassignModal / EscalateTaskModal, sized for the lead form.\n\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.modalCard {\n  width: 100%;\n  max-width: 920px;\n  max-height: calc(100vh - 32px);\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 18px 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modalTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modalSubtitle {\n  margin-top: 4px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n\n.closeButton {\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n.closeButton:hover {\n  color: #111827;\n}\n\n.modalBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 18px;\n}\n\n.modalFooter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.footerSpacer {\n  flex: 1 1 auto;\n}\n\n.modalSecondaryAction {\n  min-width: 64px;\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.modalSecondaryAction:disabled {\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.modalDangerAction {\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.modalDangerAction:disabled {\n  border-color: #e5e7eb;\n  color: #9ca3af;\n}\n\n.modalPrimaryAction {\n  min-width: 64px;\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #1f2937;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.modalPrimaryAction:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: default;\n}\n\n.modalSecondaryAction:focus-visible,\n.modalPrimaryAction:focus-visible,\n.closeButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `LeadWorkModal-module__modalOverlay___aGtkK`,
	"modalCard": `LeadWorkModal-module__modalCard____Yo0W`,
	"modalHeader": `LeadWorkModal-module__modalHeader___bDPT8`,
	"modalTitle": `LeadWorkModal-module__modalTitle___nggga`,
	"modalSubtitle": `LeadWorkModal-module__modalSubtitle___Z2Xy6`,
	"closeButton": `LeadWorkModal-module__closeButton___VCKmL`,
	"modalBody": `LeadWorkModal-module__modalBody___rfzQX`,
	"modalFooter": `LeadWorkModal-module__modalFooter___eP7Lw`,
	"footerSpacer": `LeadWorkModal-module__footerSpacer___zwLPU`,
	"modalSecondaryAction": `LeadWorkModal-module__modalSecondaryAction___mS9YM`,
	"modalDangerAction": `LeadWorkModal-module__modalDangerAction___A5q5e`,
	"modalPrimaryAction": `LeadWorkModal-module__modalPrimaryAction___Jy0ww`
};
module.exports = ___CSS_LOADER_EXPORT___;
